
import { get, put, post, del } from './connection'

const API_BASE_URL = process.env.REACT_APP_API_URL;
const dashboardApi = { 
    
    getVacanciesByClients: async (queryString = "") => {
        //  debugger;
        try {
            return get(`/dashboard/get-vacancy-by-accounts${queryString}`);
        } catch (error) {
            debugger
            throw new Error("Error while fetching client vacancy details");
        }
    },  

    getOpenPositionsByEmploymentType: async (queryString) => {
        // debugger;
        try {
            return get("/dashboard/get_open_position_by_employment_type");
        } catch (error) {
            throw new Error("Error while fetching open positions by employment type");
        }
    },
    
    getCurrentOpenings: async (queryString) => {
        try {
            return get(`/dashboard/get_current_openings${queryString}`);
        } catch (error) {
            throw new Error("Error while fetching current openings");
        }
    },

    getUpcomingCandidateEvents: async (queryString="") => {
        try {
            return get(`/dashboard/get_upcoming_candidate_events${queryString}`);
        } catch (error) {
            throw new Error("Error while fetching upcoming candidate events");
        }
    },

    getVacancyOverview: async (queryString = "") => {
    try {
        // debugger
        return get(`/dashboard/get_vacancy_overview${queryString}`);
    } catch (error) {
        throw new Error("Error while fetching vacancy overview");
    }
},

getJobActivityLog: async (queryString = "") => {
    try {
        return get(`/dashboard/get_job-activity_log${queryString}`);
    } catch (error) {
        throw new Error("Error while fetching activity log");
    }
},

getPositionsByCountry: async (queryString = "") => {
        // debugger;
        try {
            return get(`/dashboard/get_position_by_country${queryString}`);
        } catch (error) {
            throw new Error("Error while fetching open positions by employment country");
        }
    },



};

export default dashboardApi;